import {Box, Divider, Typography} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import moment from 'moment'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {OrderRequestGroupResponse} from '../../declarations/types'
import {SplitLoadOrderIntakePayload} from '../../BulkCement/containers/SplitLoad/buildSplitLoadPayload'
import {OrderCardHeader} from './OrderCardHeader'
import {MaterialsList} from './MaterialsList'
import {OrderAdditionalInfo} from './OrderAdditionalInfo'

const useStyles = makeStyles(() => ({
  orderCard: {
    border: '2px solid #BBDEB3',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    background: '#FBFFF9'
  },
  orderCardError: {
    border: '2px solid #FC8181',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    background: '#FFF5F5'
  },
  orderCardHeader: {
    marginBottom: '12px'
  },
  statusIcon: {
    marginRight: '8px'
  }
}))

interface SplitLoadOrderCardProps {
  orderResponse: OrderRequestGroupResponse
  payload: SplitLoadOrderIntakePayload
  index: number
  quantityUom: string
}

export const SplitLoadOrderCard: React.FC<SplitLoadOrderCardProps> = ({
  orderResponse,
  payload,
  index,
  quantityUom
}) => {
  const classes = useStyles()
  const {t} = useTranslation()

  const isSuccess = orderResponse.isSuccess
  const {salesOrderLineItems} = payload
  const firstLineItem = salesOrderLineItems[0]

  const formattedDate = moment(firstLineItem.deliveryDate).format('DD.MM.YYYY')
  const formattedTime = `${firstLineItem.deliveryTime.earliest} - ${firstLineItem.deliveryTime.latest}`

  return (
    <Box
      className={isSuccess ? classes.orderCard : classes.orderCardError}
      data-test-id={`split-load-order-card-${isSuccess ? 'success' : 'error'}-${index}`}
    >
      <Box className={classes.orderCardHeader}>
        <OrderCardHeader
          isSuccess={isSuccess}
          index={index}
          formattedDate={formattedDate}
          formattedTime={formattedTime}
          statusIconClassName={classes.statusIcon}
        />
      </Box>

      <Divider style={{marginBottom: '12px'}} />

      <MaterialsList salesOrderLineItems={salesOrderLineItems} quantityUom={quantityUom} />

      <OrderAdditionalInfo payload={payload} firstLineItem={firstLineItem} />

      {!isSuccess && (
        <Box
          mt={2}
          p={2}
          style={{background: '#FED7D7', borderRadius: '4px', border: '1px solid #FC8181'}}
        >
          <Typography variant="body2" color="error">
            {t('orderIntake.confirmationScreen.orderFailed')}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
